import { render, staticRenderFns } from "./SidebarStyleSuperAdmin.vue?vue&type=template&id=517e9c51&"
import script from "./SidebarStyleSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./SidebarStyleSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports